"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchTokenSelectInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const react_intl_1 = require("react-intl");
const types_1 = require("@framework/types");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const SearchTokenSelectInput = (props) => {
    const { prefix } = props;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const emptyReward = (0, react_hook_form_1.useWatch)({ name: "emptyReward" });
    const disabled = prefix === "reward" && emptyReward;
    return ((0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: `${prefix}.tokenType`, options: types_1.TokenType, label: formatMessage({ id: `form.labels.${prefix}` }), disabled: disabled }));
};
exports.SearchTokenSelectInput = SearchTokenSelectInput;
//# sourceMappingURL=index.js.map